let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("EgLgS")).then(() => parcelRequire('b8Qs4'));